module.exports = __webpack_public_path__ + "static/withjoy-926ab07e29aadd9f6f3c63464f0ee0c4.png";